import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import WhyTrainingMatters from './components/WhyTrainingMatters';
import WhatIsIncluded from './components/WhatIsIncluded';
import HowSystemBuilt from './components/HowSystemBuilt';
import PopularDirections from './components/PopularDirections';
import HowToChoose from './components/HowToChoose';
import WhenCompanyNeeds from './components/WhenCompanyNeeds';
import TypicalMistakes from './components/TypicalMistakes';
import WhyProgramsWork from './components/WhyProgramsWork';
import EncyclopediaMapSection from './components/EncyclopediaMapSection';
import ReadNextSection from './components/ReadNextSection';
import AboutExpertSection from './components/AboutExpertSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import RoiCtaStrip from '@/components/feature/RoiCtaStrip';
import Footer from '@/components/feature/Footer';

const encyclopediaNavLinks = [
  { label: 'Разделы', target: 'what-included' },
  { label: 'Как выбрать', target: 'how-choose' },
  { label: 'Карта', target: 'encyclopedia-map' },
  { label: 'Об эксперте', target: 'about' },
  { label: 'FAQ', target: 'faq' },
];

export default function EncyclopediaHubPage() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      
      <SeoTitle title="Энциклопедия корпоративного обучения | Business Training" />
      <PageJsonLd />

      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={encyclopediaNavLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection scrollTo={scrollTo} />
        <WhyTrainingMatters />
        <WhatIsIncluded />
        <RoiCtaStrip />
        <HowSystemBuilt />
        <PopularDirections />
        <HowToChoose />
        <WhenCompanyNeeds />
        <TypicalMistakes />
        <WhyProgramsWork />
        <EncyclopediaMapSection />
        <ReadNextSection />
        <AboutExpertSection />
        <CTASection />
        <FAQSection />
        <Footer />
      </div>
    </>
  );
}